// extracted by mini-css-extract-plugin
export var subtitle = "_ax-2";
export var title = "_ax-0";
export var titleNoWrap = "_ax-1";